import { Pipe, PipeTransform } from '@angular/core';
import camelCase from 'lodash/camelCase';

@Pipe({
  name: 'caCamelCase',
  standalone: false
})
export class CamelCasePipe implements PipeTransform {
  transform(value: unknown) {
    return value == null ? null : camelCase(`${value}`);
  }
}
